import React, { Component } from 'react';
import { View } from 'react-native';
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import { faPowerOff } from '../../assets/consts/faCharCodes';

export default class DeviceToggle extends Component {
    constructor(props) {
        super(props);

    }

    // toggle() {
    //     this.setState({ currentValue: !this.state.currentValue }, this.handleOnToggle);
    // }


    handleOnToggle = () => {
        if (this.props.onToggle) {
            this.props.onToggle();
        }
    }

    render() {
        return (
            <View style={this.props.style}>
                <FontAwesomeIcon
                    icon={this.props.icon || faPowerOff}
                    size={42}
                    color={this.props.value ? this.props.activeColor || "#00F700" : "#ccc"}
                    onPress={() => this.handleOnToggle()} />

            </View>
        );
    }
}
